import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const useIsLoggedIn = () => {
  return useQuery({
    queryKey: ['isLoggedIn'],
    queryFn: () =>
      axios
        .get(envApiUrl + '/users/isLoggedIn', {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => {
          console.log('useIsLoggedIn response', response);
          return { loggedIn: true };
        })
        .catch(() => {
          return { loggedIn: false };
        }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: false, // Don't retry on failure
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: false, // Don't refetch on mount if data exists
  });
};
